import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { TRACK_EVENTS } from 'app-webtech-core/modules/playbackSession/actions/types';
import { VIDEO_LOADED, VIDEO_LOADED_FOR_BI } from './types';
import { selectors } from '../../../selectors';
import { appLoaded, setLaunchState } from '../../application/actions';
import { LAUNCH_STATE } from '../../application/constants';

const videoLoaded = actionCreator(VIDEO_LOADED);
const videoLoaded4BI = actionCreator(VIDEO_LOADED_FOR_BI);
const startTrackingAction = actionCreator(TRACK_EVENTS);

export const videoLoadedThunkAction = () => (dispatch, getState) => {
  const state = getState();
  const { videoLoaded: isVideoLoaded } = selectors.application.properties(state);
  const { trackClipEvents } = selectors.playbackSession.properties(state);

  if (!isVideoLoaded) {
    dispatch(videoLoaded());
    dispatch(videoLoaded4BI());
    dispatch(setLaunchState(LAUNCH_STATE.VIDEO_LOADED));
    dispatch(appLoaded());
  } else if (!state.viral.isEnabled) {
    dispatch(videoLoaded4BI());
  }
  if (!trackClipEvents) {
    dispatch(startTrackingAction({ trackClipEvents: true }));
  }
};
